import { PageTemplateContent, SkeletonLoading } from 'app/common/templates-next/page-template'


export const SupplierSelectorLoading = () => {
  return (
    <PageTemplateContent>
      <SkeletonLoading rows={3} />
    </PageTemplateContent>
  )
}
